import { useRequest } from 'ahooks';
import { Button, Layout, Space, Spin } from 'antd';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { loginController } from '../api';

function isWeChat() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  // @ts-ignore
  if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

const cdnURL = ((w: Window) => {
  return `${w.location.protocol}//${w.location.host}/app`;
})(window);

const apkMapping = [
  { domain: ['zhihuiyinfu.app'], apk: 'zhihuiyinfu.app-20241019.apk' },
  {
    domain: ['fengyin.app'],
    apk: 'fengyin.app-20241019.apk',
    newApk: 'zhongxin-v0.0.12.apk',
  },
  { domain: ['huayinfu.app'], apk: 'huayinfu.app-20241019.apk' },
  { domain: ['huyin.app'], apk: 'huyin.app-20241019.apk' },
  { domain: ['shengshi.app'], apk: 'shengshi.app-20250619.apk' },
  { domain: ['zhongrong.dev'], apk: 'zhongrong.dev-20250803.apk' },
  //
  {
    domain: ['shw.erong.org', '8.153.104.70:8080'],
    apk: 'shw.erong.org-20240828.apk',
  },
  {
    domain: ['www.erong.org', '8.153.104.70:8081'],
    apk: 'www.erong.org-20240828.apk',
  },
  {
    domain: ['sxh.erong.org', '8.153.104.70:8082'],
    apk: 'sxh.erong.org-20240828.apk',
  },
  {
    domain: ['shs.erong.org', '.153.104.70:8083'],
    apk: 'shs.erong.org-20240828.apk',
  },
  {
    domain: ['shx.erong.org', '8.153.104.70:8084'],
    apk: 'shx.erong.org-20240828.apk',
  },
  {
    domain: ['wxx.erong.org', '8.153.104.70:8085'],
    apk: 'wxx.erong.org-20240828.apk',
  },
  {
    domain: ['shj.erong.org', '8.153.104.70:8086'],
    apk: 'shj.erong.org-20250331.apk',
  },
  {
    domain: ['8.153.91.226:11112'],
    apk: 'wqm.20250905.apk',
    newApk: 'wanqimeng-v0.0.12.apk',
  },
];

export default function AppDownload() {
  const inWechat = isWeChat();

  const downloadUrl = useMemo(() => {
    const value = apkMapping.find(({ domain }) =>
      domain.includes(window.location.host),
    );
    return value?.apk;
  }, []);

  const { data, loading } = useRequest(() => {
    return loginController.getAppDownloadConfig();
  });

  return (
    <Layout>
      <Layout.Content style={{ height: '100vh' }}>
        <div style={{ textAlign: 'center', marginTop: 100 }}>
          <h1>下载APP</h1>
          {inWechat && <p>请使用手机浏览器打开</p>}
          <Spin spinning={loading}>
            <Space direction="vertical">
              {data?.apkName ? (
                <Button type="link" href={`${cdnURL}/new/${data?.apkName}`}>
                  点击下载新版 app
                </Button>
              ) : (
                <>无 app</>
              )}
            </Space>
          </Spin>
        </div>
      </Layout.Content>
    </Layout>
  );
}
